export const getSelectedStudyCount = (
  selectAll: boolean,
  studyIdsCount: number,
  studyCount: number
) => {
  return selectAll ? studyCount - studyIdsCount : studyIdsCount
}
